import React, { useEffect, useState } from "react";
import './Navigation.css'
import { Link } from "react-router-dom";

const Navigation = () => {
    const [width, setWidth] = useState({
        winWidth: window.innerWidth
    });

    const detectSize = () => {
        setWidth({
            winWidth: window.innerWidth
        })
    }

    useEffect(() => {
        window.addEventListener('resize', detectSize)

        return (() => {
            window.removeEventListener('resize', detectSize)
        })
    }, [width])
    return (
        <>
            <nav className="navbar navbar-expand-lg navbar-dark fixed-top" id="mainNav" style={{ userSelect: "none" }}>
                <div className="container">
                    <Link className="navbar-brand" to="/">
                        {/* <img src="assets/img/navbar-logo.svg" alt="..." /> */}
                        <span className="company-name">MV Nails House</span>
                    </Link>
                    <button
                        className="navbar-toggler"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#navbarResponsive"
                        aria-controls="navbarResponsive"
                        aria-expanded="false"
                        aria-label="Toggle navigation"
                    >
                        Menu
                        <i className="fas fa-bars ms-1" />
                    </button>
                    <div className="collapse navbar-collapse" id="navbarResponsive">
                        <ul className="navbar-nav text-uppercase ms-auto py-4 py-lg-0">
                            <li className="nav-item">
                                <Link className="nav-link" to="/about">
                                    About
                                </Link>
                            </li>
                            <li className="nav-item">
                                <Link className="nav-link" to="/services">
                                    Services
                                </Link>
                            </li>
                            {/* <li className="nav-item">
                                <a className="nav-link" href="#gallery">
                                    Gallery
                                </a>
                            </li> */}
                            {/* <li className="nav-item">
                                <a className="nav-link" href="#timing">
                                    Timing
                                </a>
                            </li> */}
                            <li className="nav-item">
                                <Link className="nav-link" to="/contact">
                                    Contact
                                </Link>
                            </li>
                            {width?.winWidth > 990 ?
                                <li className="nav-item">
                                    {/* <button
                                        className="btn btn-primary  text-uppercase" style={{ marginLeft: "10px" }}
                                    >
                                        BOOK NOW
                                    </button> */}
                                    <Link className="nav-link book-btn" to="/contact">
                                        BOOK NOW
                                    </Link>
                                </li>
                                : ''}
                        </ul>
                    </div>
                </div>
            </nav>
        </>
    )
}

export default Navigation;